<template>
  <div class="animate-spin">
    <Icon name="MdiLoading" />
  </div>
</template>
